import './DragAndDropHorizontal.css';
import '../../chaptercontainer.css';
import questionIcon from '../images/question.png';

const DragAndDropHorizontal = ({
  question,
  options = [],
  selectedAnswers = [],
  isAnswerChecked,

  slotsCount = 0,
  expectedAnswers = [],
  rows = [],
  sentenceSegments = [],

  getOptionValueById,
  onAnswersChange,

  showQuestion = true,
  insideSimpleApplication = false,
}) => {
  if (!question) {
    return null;
  }

  const hasInlineSentence =
    Array.isArray(sentenceSegments) &&
    sentenceSegments.length > 0;

  const safeSelectedAnswers =
    Array.isArray(selectedAnswers) &&
    selectedAnswers.length === slotsCount
      ? selectedAnswers
      : Array(slotsCount).fill(null);

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const readDraggedOptionId = (event) => {
    try {
      const payload =
        event.dataTransfer.getData('application/json');

      if (payload) {
        const parsedPayload = JSON.parse(payload);

        if (parsedPayload?.id) {
          return parsedPayload.id;
        }
      }
    } catch (error) {
      // fallback
    }

    return event.dataTransfer.getData('text/plain');
  };

  const updateAnswers = (nextAnswers) => {
    onAnswersChange?.(nextAnswers);
  };

  const placeOptionInSlot = (
    slotIndex,
    optionId
  ) => {
    if (
      isAnswerChecked ||
      !optionId
    ) {
      return;
    }

    const nextAnswers = [
      ...safeSelectedAnswers,
    ];

    const existingIndex =
      nextAnswers.indexOf(optionId);

    if (existingIndex !== -1) {
      nextAnswers[existingIndex] = null;
    }

    nextAnswers[slotIndex] = optionId;

    updateAnswers(nextAnswers);
  };

  const handleDropOnSlot = (
    event,
    slotIndex
  ) => {
    event.preventDefault();

    const optionId =
      readDraggedOptionId(event);

    if (!optionId) {
      return;
    }

    placeOptionInSlot(
      slotIndex,
      optionId
    );
  };

  const handleDropOnOptions = (
    event
  ) => {
    event.preventDefault();

    if (isAnswerChecked) {
      return;
    }

    const optionId =
      readDraggedOptionId(event);

    if (!optionId) {
      return;
    }

    const nextAnswers =
      safeSelectedAnswers.map(
        (item) =>
          item === optionId
            ? null
            : item
      );

    updateAnswers(nextAnswers);
  };

  const handleSlotClick = (
    slotIndex
  ) => {
    if (isAnswerChecked) {
      return;
    }

    const nextAnswers = [
      ...safeSelectedAnswers,
    ];

    nextAnswers[slotIndex] = null;

    updateAnswers(nextAnswers);
  };

  const handleOptionClick = (
    optionId
  ) => {
    if (isAnswerChecked) {
      return;
    }

    const firstEmptySlot =
      safeSelectedAnswers.findIndex(
        (item) =>
          item === null ||
          item === undefined ||
          item === ''
      );

    if (firstEmptySlot !== -1) {
      placeOptionInSlot(
        firstEmptySlot,
        optionId
      );
    }
  };

  const handleDragStart = (
    event,
    optionId
  ) => {
    if (
      isAnswerChecked ||
      !optionId
    ) {
      return;
    }

    event.dataTransfer.setData(
      'application/json',
      JSON.stringify({
        id: optionId,
      })
    );

    event.dataTransfer.setData(
      'text/plain',
      String(optionId)
    );

    event.dataTransfer.effectAllowed =
      'move';
  };

  const renderSlot = (
    slotIndex,
    inline = false
  ) => {
    const optionId =
      safeSelectedAnswers[
        slotIndex
      ] ?? null;

    const value =
      getOptionValueById?.(
        question,
        optionId
      ) || '';

    const expectedValue =
      expectedAnswers[
        slotIndex
      ] ?? '';

    const isCorrectSlot =
      isAnswerChecked &&
      value &&
      value === expectedValue;

    const isWrongSlot =
      isAnswerChecked &&
      value &&
      value !== expectedValue;

    const className = [
      'drag-horizontal-slot-bc',

      inline
        ? 'drag-horizontal-inline-slot-bc'
        : '',

      value
        ? 'filled'
        : '',

      isCorrectSlot
        ? 'correct'
        : '',

      isWrongSlot
        ? 'incorrect'
        : '',
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <button
        key={`horizontal-slot-${slotIndex}`}
        type="button"
        className={className}
        onDragOver={handleDragOver}
        onDrop={(event) =>
          handleDropOnSlot(
            event,
            slotIndex
          )
        }
        onClick={() =>
          handleSlotClick(
            slotIndex
          )
        }
        draggable={
          !isAnswerChecked &&
          Boolean(value)
        }
        onDragStart={(event) =>
          optionId &&
          handleDragStart(
            event,
            optionId
          )
        }
        disabled={isAnswerChecked}
      >
        {value && (
          <span className="drag-horizontal-slot-filled-bc">
            {value}
          </span>
        )}
      </button>
    );
  };

  let currentSlotIndex = 0;

 return (
  <div
    className={
      insideSimpleApplication
        ? ''
        : 'quiz-content-scroll-bc'
    }
  >
    <div className="drag-horizontal-container-bc">

        {/* INTREBAREA NORMALA */}

        {showQuestion &&
          question.question && (
            <div className="drag-horizontal-title-bc">

              <p className="drag-horizontal-title-text-bc">
                {question.question}
              </p>

            </div>
          )}


        {/* PROPOZITIA CU SLOT INLINE */}

        {hasInlineSentence ? (

          <div
            className="drag-horizontal-equation-bc"
          >

            <img
              src={questionIcon}
              alt="Question"
              className="drag-horizontal-question-icon-bc"
            />

            <div className="drag-horizontal-equation-content-bc">

              {sentenceSegments.map(
                (
                  segment,
                  index
                ) => {

                  const isSlotSegment =
                    segment ===
                      '__SLOT__' ||
                    segment ===
                      '{{slot}}' ||
                    (
                      typeof segment ===
                        'string' &&
                      /^_{3,}$/.test(
                        segment
                      )
                    );

                  if (
                    !isSlotSegment
                  ) {
                    return (
                      <span
                        key={`horizontal-inline-text-${index}`}
                        className="drag-horizontal-static-text-bc"
                      >
                        {segment}{' '}
                      </span>
                    );
                  }

                  const slotIndex =
                    currentSlotIndex;

                  currentSlotIndex += 1;

                  return renderSlot(
                    slotIndex,
                    true
                  );
                }
              )}

            </div>

          </div>

        ) : (

          /* VARIANTA CU ROWS */

          <div className="drag-horizontal-rows-bc">

            {rows.map(
              (
                row,
                rowIndex
              ) => {

                const rowSlots =
                  Math.max(
                    0,
                    Number(
                      row?.slots
                    ) || 0
                  );

                const rowLabel =
                  row?.label ?? '';

                const startIndex =
                  currentSlotIndex;

                currentSlotIndex +=
                  rowSlots;

                return (
                  <div
                    key={`horizontal-dnd-row-${rowIndex}`}
                    className="drag-horizontal-row-bc"
                  >

                    {rowLabel && (
                      <p className="drag-horizontal-row-label-bc">
                        {rowLabel}
                      </p>
                    )}

                    <div className="drag-horizontal-row-slots-bc">

                      {Array.from(
                        {
                          length:
                            rowSlots,
                        },
                        (
                          _,
                          index
                        ) =>
                          renderSlot(
                            startIndex +
                              index
                          )
                      )}

                    </div>

                  </div>
                );
              }
            )}

          </div>
        )}


        {/* UN SINGUR SLOT */}

        {slotsCount === 1 && (

          <div className="drag-horizontal-single-options-wrapper-bc">

            <div
              className="drag-horizontal-single-options-bc"
              onDragOver={
                handleDragOver
              }
              onDrop={
                handleDropOnOptions
              }
            >

              {options.map(
                (option) => {

                  const isSelected =
                    safeSelectedAnswers[
                      0
                    ] ===
                    option.id;

                  return (
                    <div
                      className="drag-horizontal-option-wrapper-bc"
                      key={
                        option.id
                      }
                    >

                      <button
                        type="button"

                        className={`drag-horizontal-option-single-bc${
                          isSelected
                            ? ' selected'
                            : ''
                        }`}

                        style={
                          isSelected
                            ? {
                                border:
                                  '2px solid #2ecc40',

                                background:
                                  '#eaffea',

                                color:
                                  '#2ecc40',

                                boxShadow:
                                  '0 2px 0 0 #2ecc40, 0 0 0 0 #2ecc40, 0 0 0 0 #2ecc40, 0 5px 0 0 #2ecc40',
                              }
                            : {}
                        }

                        draggable={
                          !isSelected &&
                          !isAnswerChecked
                        }

                        onDragStart={(
                          event
                        ) => {
                          if (
                            !isSelected &&
                            !isAnswerChecked
                          ) {
                            handleDragStart(
                              event,
                              option.id
                            );
                          }
                        }}

                        onClick={() => {
                          if (
                            !isAnswerChecked
                          ) {
                            placeOptionInSlot(
                              0,
                              option.id
                            );
                          }
                        }}

                        disabled={
                          isAnswerChecked
                        }
                      >
                        {
                          option.label
                        }
                      </button>

                    </div>
                  );
                }
              )}

            </div>

          </div>
        )}


        {/* MAI MULTE SLOTURI */}

        {slotsCount !== 1 && (

          <div
            className="drag-horizontal-options-bc"

            onDragOver={
              handleDragOver
            }

            onDrop={
              handleDropOnOptions
            }
          >

            {options.map(
              (option) => {

                const isUsed =
                  safeSelectedAnswers.includes(
                    option.id
                  );

                if (isUsed) {
                  return null;
                }

                return (
                  <button
                    key={option.id}
                    type="button"

                    className="drag-horizontal-option-bc"

                    draggable={
                      !isAnswerChecked
                    }

                    onDragStart={(
                      event
                    ) => {
                      if (
                        !isAnswerChecked
                      ) {
                        handleDragStart(
                          event,
                          option.id
                        );
                      }
                    }}

                    onClick={() => {
                      if (
                        !isAnswerChecked
                      ) {
                        handleOptionClick(
                          option.id
                        );
                      }
                    }}

                    disabled={
                      isAnswerChecked
                    }
                  >
                    {
                      option.label
                    }
                  </button>
                );
              }
            )}

          </div>
        )}

        </div>
       
    </div>
  );
};

export default DragAndDropHorizontal;